import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ChangePassword from './change-password';
import ChangePin from './change-pin';

const UI = ({ match }) => (
    <Switch>
        <Route path={`${match.url}/change-password`} component={ChangePassword} />
        <Route path={`${match.url}/change-pin`} component={ChangePin} />
        <Redirect to="/error" />
    </Switch>

);
export default UI;
